import Layout from '@layout/Index'

export const cityMap = [
  {
    path: '/city-map',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "customer-table" */ './pages/CityMapTable.vue'),
        name: '区域管理',
        meta: {
          title: '区域管理',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/city-map/city-map.route.js